(angular => {
  'use strict';

  angular.module('Event').controller('Event.ExportTokenCtrl', [
    '$scope',
    '$filter',
    '$timeout',
    '$mdDialog',
    'lodash',
    'Loader',
    'Toast',
    'EventService',
    'event',
    'FormRedirectService',
    'API',
    ExportTokenCtrl
  ]);

  function ExportTokenCtrl($scope, $filter, $timeout, $mdDialog, lodash, Loader, Toast, EventService, event, FormRedirectService, API) {
    this.event = event;
    this.eventDays = [];
    this.query = {};
    this.eventDays = EventService.getEventDays(event);
    this.dateEventFind = this.eventDays[0];

    this.exportToken = () => {
      FormRedirectService
        .submit(`${API}/event/${this.dateEventFind}/exportToken`, event);

        $mdDialog.hide();
        Toast.show('Planilha exportada com sucesso', 'success');
        this.loadData();
    };

    this.cancel = $mdDialog.cancel;
  }
})(angular || {});
